import React from 'react';
import Skeleton from 'ui/Skeleton';

const AdvancedSearchResultCardLoading = () => {
  return (
    <div className="AdvancedSearchResultCard bg-white">
      <Skeleton height={40} />
      <Skeleton
        height={20}
        lines={2}
        className="AdvancedContentSearchRoot-LoadingCard"
      />
      <Skeleton height={20} lines={2} className="mt-8" />
    </div>
  );
};

export default AdvancedSearchResultCardLoading;
